export default __webpack_public_path__ + "static/media/ForwardInactive.33fc2ce5.svg";